import React, { useState, useEffect } from 'react';
import { SearchOrderGlobalBinded } from '../../models/Orders_v2';
import { ordersToConceptos } from '../../utils/global.ordersToConceptos';

function GlobalSectionReportDownload({ billList, label, chargeShipping }: { billList: SearchOrderGlobalBinded[], label: string, chargeShipping: boolean }) {
    const [csvFile, setCsvFile] = useState(null);

    useEffect(() => {
        if (billList.length) {
            const csvHead = `Orden,Subtotal,IVA,IEPS,total`;
            const csvBody = ordersToConceptos(billList).map((orderConceptos) => {

                const IVA = orderConceptos.impuestos.filter(tax => tax.type === 'iva').reduce((p, tax) => p += tax.tasa || 0, 0) * orderConceptos.valorUnitario;
                const IEPS = orderConceptos.impuestos.filter(tax => tax.type === 'ieps').reduce((p, tax) => p += tax.tasa || 0, 0) * orderConceptos.valorUnitario;
                return [orderConceptos.noIdentificacion, orderConceptos.valorUnitario.toFixed(2), IVA.toFixed(2), IEPS.toFixed(2), (orderConceptos.valorUnitario + IVA + IEPS).toFixed(2)].join(',');
            })
            const csv = [csvHead].concat(csvBody).join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            setCsvFile(URL.createObjectURL(blob));
        } else {
            setCsvFile(null);
        }
    }, [billList, chargeShipping]);

    if (!csvFile) {
        return (
            <span className="_downloadCsv disabled">
                Descargar lista como CSV
            </span>
        )
    }
    return (
        <a className="_downloadCsv" href={csvFile} download={`Pedidos_${label.split(' ').join('_').replace('º', '').replace(',', '')}.csv`}>
            Descargar lista como CSV
        </a>
    )

}

export default GlobalSectionReportDownload;